import { useEffect } from 'react'
import { P4 } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import { toMoneySymbolsFormat } from 'modules/asset/AssetPage/assetPageUtils'
import styles from './CustomTooltip.module.scss'

const CustomTooltip = ({
  active,
  payload,
  handleSetPrevSum,
  prices: { priceSlugFirst, priceSlugSecond },
  slugs: { slugFirst, slugSecond },
  slugCurrency
}) => {
  useEffect(() => {
    const handleSum = () => {
      if (active && payload && payload?.length) {
        const {
          payload: { priceSlug1, priceSlug2 }
        } = payload[0]

        const slugFirstPercentage = ((priceSlug1 - priceSlugFirst) / priceSlugFirst) * 100
        const slugSecondPercentage = ((priceSlug2 - priceSlugSecond) / priceSlugSecond) * 100

        handleSetPrevSum(slugFirstPercentage, slugSecondPercentage)
      }
    }
    return handleSum()
  }, [active, handleSetPrevSum, payload, priceSlugFirst, priceSlugSecond])

  if (active && payload && payload?.length) {
    const {
      payload: { labelReturnsToolTip, volumeSlug1 = 0, volumeSlug2 = 0, priceSlug1 = 0, priceSlug2 = 0 }
    } = payload[0]
    return (
      <div className={styles.CustomTooltip}>
        <div className={styles.Table}>
          <div className={styles.Container}>
            <P4 weight="semibold" className={`${styles.Header} ${styles.Black}`}>
              {labelReturnsToolTip}
            </P4>

            <P4 weight="light" className={styles.Label}>
              {slugFirst}
            </P4>

            <P4 weight="light" className={styles.Label}>
              {slugSecond}
            </P4>
          </div>

          <div className={`${styles.Container}`}>
            <P4 weight="light" className={`${styles.Header} ${styles.Grey}`}>
              Price
            </P4>

            <P4 weight="light" className={styles.Value}>
              ${Number(priceSlug1)?.toFixed(2)}
            </P4>

            <P4 weight="light" className={styles.Value}>
              ${Number(priceSlug2)?.toFixed(2)}
            </P4>
          </div>

          <div className={`${styles.Container}`}>
            <P4 weight="light" className={`${styles.Header} ${styles.Grey}`}>
              Volume
            </P4>

            <P4 weight="light" className={`${styles.ValueHeader} `}>
              {slugCurrency}
              {volumeSlug1 ? toMoneySymbolsFormat(volumeSlug1?.toFixed(0) || 0) : '-'}
            </P4>

            <P4 weight="light" className={`${styles.ValueHeader} `}>
              {slugCurrency}
              {volumeSlug2 ? toMoneySymbolsFormat(volumeSlug2?.toFixed(0) || 0) : '-'}
            </P4>
          </div>
        </div>
      </div>
    )
  }

  return null
}

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      payload: PropTypes.shape({
        labelReturnsToolTip: PropTypes.string,
        priceSlug1: PropTypes.number,
        priceSlug2: PropTypes.number,
        volumeSlug1: PropTypes.number,
        volumeSlug2: PropTypes.number
      })
    })
  ),
  prices: PropTypes.shape({
    priceSlugFirst: PropTypes.number,
    priceSlugSecond: PropTypes.number
  }),
  slugs: PropTypes.shape({
    slugFirst: PropTypes.string,
    slugSecond: PropTypes.string
  }),
  slugCurrency: PropTypes.string,
  handleSetPrevSum: PropTypes.func
}

CustomTooltip.defaultProps = {
  active: false,
  payload: [],
  prices: {},
  slugs: {
    slugFirst: '',
    slugSecond: ''
  },
  slugCurrency: '',
  handleSetPrevSum: () => {}
}

export default CustomTooltip
